<!--
 * @Description: 
 * @Author: dezhi
 * @Date: 2020-02-19 15:46:56
 * @LastEditTime: 2022-12-16 17:51:39
 * @LastEditors: zhaoshuai
 -->
<template>
  <header class="header flex sharing-h">
    <div
      class="wrapper flex sharing-head"
      :class="{ bordernone: $route.path == '/login' }"
    >
      <div class="d-flex align-items-end">
        <img class="logo" src="@/assets/images/login-logo1.png" />
        <!-- <div class="logo-area">中文写作能力评价评定</div> -->
      </div>
      <div
        class="user-info align-items-end"
        v-if="loginStatus && $route.path != '/login'"
      >
        {{ userInfo.realName ? userInfo.realName : userInfo.userName }}，您好！
        <a @click="logout">退出</a>
      </div>
    </div>
  </header>
</template>

<script>
// @ is an alias to /src

import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("account");
export default {
  name: "Header",
  components: {},
  data() {
    return {
      userInfo: {},
    };
  },
  computed: {
    ...mapState({
      loginStatus: (state) => state.loginStatus,
    }),
  },
  mounted() {
    let loginStatus =
      localStorage.getItem("loginStatus") == "true" ? true : false;
    this.userInfo = localStorage.getItem("apply_userInfo")
      ? JSON.parse(localStorage.getItem("apply_userInfo"))
      : "";
    this.$store.commit("account/setLoginStatus", loginStatus);
  },
  methods: {
    logout() {
      let me = this;

      this.$confirm({
        title: "退出",
        okText: "确定",
        cancelText: "取消",
        content: () => (
          <div style="color:#B01F21;">确认退出,已上传/填写将会保存?</div>
        ),
        onOk() {
          me.$store.commit("account/logout");
          me.$router.replace("/");
        },
      });
    },
  },
};
</script>

<style>
.header {
  background: #fff;
  text-align: left;
}
.header > div {
  /* border-bottom: 1px solid #f9be00;
  padding-bottom: 15px;
  margin-top: 15px; */
}
.header > .bordernone {
  border: none;
}
.logo-area {
  color: rgba(145, 38, 43, 1);
}
.user-info {
  bottom: 0;
}
.user-info a {
  color: #b01f21;
}
.logo {
  height: 52px;
  width: 272px;
}
.sharing-head {
  justify-content: space-between;
  align-items: baseline;
}
@media (max-width: 768px) {
  .sharing-head {
    align-items: flex-end;
  }
  .logo {
    height: 37px;
    width: 167px;
  }
}
</style>
